import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col, DropdownItem } from 'reactstrap'
import { useSelector } from 'react-redux'

import { leaveRequestSelector } from '../../../selectors'

import { FONTS } from '../../../constants'

import { Cell } from './cell'

export const DataRow = ({ teamCalendar, dates, row, publicHolidays }) => {
  const allRequests = useSelector(leaveRequestSelector.getLeaveRequestsByGroup)
  const myUser = allRequests ? allRequests.myUser : null

  return (
    teamCalendar ?
      <HeaderRow style={ { height: 50, flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
        <CellLeftCol style={ { backgroundColor: '#FFFFFF', width: 200, overflow: 'hidden', borderRight: '1px solid #EAEAEA', fontSize: FONTS.SMALL_SIZE } }>{row.label}</CellLeftCol>
        <div style={ { flex: 1, overflow: 'hidden', display: 'flex' } }>
          {dates.map(date => (
            <Cell
              key={ `data-row-${date}` }
              row={ row }
              date={ date }
              publicHolidays={ publicHolidays }
            />
          ))}
        </div>
      </HeaderRow>
      :
      <HeaderRow style={ { flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
        <div style={ { backgroundColor: '#FFFFFF', width: 200, paddingBottom: '2%', height: '100%', overflow: 'hidden', borderRight: '1px solid #EAEAEA' } }>
          <Container>
            <Row style={ { height: 50, alignItems: 'center', paddingLeft: 10 } }>
              { myUser &&
              <IconCalendar>
                {`${myUser.nick_name} ${myUser.first_name}`}
              </IconCalendar>
              }
            </Row>
            <DropdownItem divider style={ { margin: 0 } } />
            <Row style={ { padding: 10 } }>
              <IconCalendar>Icon on calendar</IconCalendar>
            </Row>
            <Row style={ { padding: 3 } }>
              <Col><Compensate /></Col>
              <Col>Compensate</Col>
            </Row>
            <Row style={ { padding: 3 } }>
              <Col><Holiday /></Col>
              <Col>Holiday</Col>
            </Row>
            <Row style={ { padding: 3 } }>
              <Col><Approved /></Col>
              <Col>Approved</Col>
            </Row>
            <Row style={ { padding: 3 } }>
              <Col style={ { display: 'flex' } }>
                <Pending /><PendingCompensate />
              </Col>
              <Col>Pending</Col>
            </Row>
          </Container>
        </div>
        <div style={ { height: 50, flex: 1, overflow: 'hidden', display: 'flex' } }>
          {dates.map(date => (
            <Cell
              key={ `data-row-${date}` }
              row={ row }
              date={ date }
            />
          ))}
        </div>
      </HeaderRow>
  )
}


const HeaderRow = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 0px 1px 0px;
`

const CellLeftCol = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1% ;
`

const IconCalendar = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const Compensate = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #0071BD;
`
const Holiday = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #7B7B7B;
`
const Approved = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #333333;
`
const Pending = styled.div`
  width: 20px;
  height: 20px;
  border-style: solid;
  border-color: #FFD27C;
  border-radius: 50%;
  border-width: 2px;
`
const PendingCompensate = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 5px ;
  border-style: solid;
  border-color: #0071BD;
  border-radius: 50%;
  border-width: 2px;
`


// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/data-row.js